// JOBE-0044.10: useFacetSearch — small hook for the predicate picker's
// "Find a facet…" input. Matches a search string against an entry's
// friendlyToken, label, gloss, and wirePredicate (substring,
// case-insensitive). Returns the filtered entries in the input order.

import { useMemo } from 'react';

export function useFacetSearch(entries, query) {
  return useMemo(() => {
    if (!query || !query.trim()) return entries;
    const q = query.trim().toLowerCase();
    return entries.filter((e) => {
      const haystack = [
        e.friendlyToken,
        e.label,
        e.gloss,
        e.wirePredicate,
      ].filter(Boolean).join(' ').toLowerCase();
      return haystack.includes(q);
    });
  }, [entries, query]);
}
